<app-nav></app-nav>


<div class="container mt-4" *ngIf="report">
    <div class="report-header">
        <div class="row">
            <div class="col-3 d-flex flex-column justify-content-between">
                <img src="assets/img/companies/JTI_Logo.png" width="130">
                <div class="d-flex flex-row">
                    <div class="mr-4">
                        <h3>{{report?.participants}}</h3>
                        <p>participants</p>
                    </div>
                    <div>
                        <h3>{{report?.sessions}}</h3>
                        <p>sessions</p>
                    </div>
                </div>
            </div>
            <div class="col-9">
                <h1>
                    Mental wellness
                    <br>report {{report?.date}}
                </h1>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-end align-items-center mt-2">
<!--        <nav class="nav">-->
<!--            <button class="nav-item" [ngClass]="{'active': false}"-->
<!--                    (click)="drawData(item)" *ngFor="let item of report.period">{{item.period}}-->
<!--            </button>-->
<!--        </nav>-->
        <div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown">
            <button
                    type="button"
                    class="btn btn-link text-dark me-2 select-dashboard"
                    id="dropdownManual"
                    ngbDropdownAnchor
                    (focus)="myDrop.open()"
            >
                <b>{{selectedDashboard}}</b>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button (click)="loadData(dashboard)"
                        class="select-dashboard"
                        [disabled]="dashboard === selectedDashboard"
                        [ngClass]="{'active': dashboard === selectedDashboard}"
                        ngbDropdownItem *ngFor="let dashboard of dashboards">{{dashboard}}</button>
            </div>
        </div>
        <!--        <p>-->
        <!--            <b>Whole company-->
        <!--            <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">-->
        <!--                <path d="M1 1L5.5 5L10 1" stroke="#10082F" stroke-width="2" stroke-linecap="round"-->
        <!--                      stroke-linejoin="round"/>-->
        <!--            </svg>-->
        <!--        </b></p>-->
    </div>

    <div class="content">
        <h4>{{title}}</h4>
        <p [innerHTML]="subtitle">
        </p>

        <div class="mb-5 row">
            <div class="col-sm-12 col-md-8">
                <lib-mixed-chart [companyName]="selectedDashboard" class="d-block mb-2" *ngIf="performanceData"
                                 [chartData]="performanceData"></lib-mixed-chart>
                <!--                <p><b>Risk of burnout-->
                <!--                    <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--                        <path d="M1 1L5.5 5L10 1" stroke="#10082F" stroke-width="2" stroke-linecap="round"-->
                <!--                              stroke-linejoin="round"/>-->
                <!--                    </svg>-->
                <!--                </b></p>-->

                <div class="position-relative">
                    <div class="legend d-flex flex-column">
                        <span class="d-flex justify-content-start align-items-center gap-2 text-uppercase"><span class=" mark grad"></span>{{selectedDashboard}}</span>
                        <span class="d-flex justify-content-start align-items-center gap-2"><span class=" mark "></span>&nbsp;Ukraine</span>

                    </div>
                    <div>
                        <nav class="nav">
                            <button class="nav-item nav-item_small"
                                    [ngClass]="{'active': currentSlide === i}"
                                    *ngFor="let data of reactions; let i = index"
                                    (click)="goTo(i)">{{data.id}}</button>
                        </nav>
                    </div>

                    <ngx-slick-carousel
                            class="carousel"
                            #slickModal="slick-carousel"
                            (afterChange)="afterSlideChange($event)"
                            [config]="{variableWidth:false, slidesToShow: 1, slidesToScroll: 1, dots: false}">
                        <div ngxSlickItem *ngFor="let data of reactions" class="slide">
                            <!--                            {{data.id}}-->
                            <lib-bar-chart
                                    [height]="363"
                                    [groupPadding]="0.3"
                                    [seriesPadding]="0.2"
                                    [colors]="['#805FFF','rgba(0,0,0,0.08)']"
                                    [data]="data"></lib-bar-chart>
                        </div>
                    </ngx-slick-carousel>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <lib-line-chart-filled class=" mb-4 ml-auto mr-auto d-block" *ngIf="anxietyData" [id]="2"
                                       [activeZoneIndex]="3"
                                       [xAxisText]="'Anxiety'"
                                       [data]="anxietyData"></lib-line-chart-filled>
                <lib-line-chart-filled class="mb-4  ml-auto mr-auto d-block" *ngIf="depressionData" [id]="3"
                                       [activeZoneIndex]="3"
                                       [xAxisText]="'Depression'"
                                       [data]="depressionData"></lib-line-chart-filled>

                <div class="table-wrapper mb-4 mt-4">
                    <p><b>Important parameters</b></p>
                    <table class="table">
                        <tr *ngFor="let row of importantParameters">
                            <td class="table-exclaim">
                                <ng-container *ngIf="row?.level === 2"><span [ngClass]="'level_'+ row.level">!</span>
                                </ng-container>
                            </td>
                            <td class="table-value" [ngClass]="'level_'+ row.level">{{row.value}}%
                            </td>
                            <td>
                                <ng-container *ngIf="row?.default_value"><span
                                        class="default_value"> ({{row?.default_value}}%)</span></ng-container>
                            </td>
                            <td>{{row.text}}</td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>
        <div class="mb-2">
            <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0">
                <ngb-panel>
                    <ng-template ngbPanelHeader let-opened="opened">
                        <div class="accordion-button custom-header justify-content-between"
                             [class.collapsed]="!opened">
                            <button ngbPanelToggle class="toggle-details    " [ngClass]="{'opened': opened}">
                                <b>See details</b>
                                <svg width="14" height="9" viewBox="0 0 14 9" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M13 7.90527L7 1.90527L1 7.90527" stroke="#10082F" stroke-width="2"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <ng-container *ngFor="let bar of barValues">
                            <lib-progressbar-stacked [barTitle]="bar.barTitle"
                                                     [values]="bar.values"></lib-progressbar-stacked>
                        </ng-container>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
        <div class="mt-2">
            <app-recommendations [lang]="'en'" *ngIf="recommendations" [results]="{recommendations}"></app-recommendations>
        </div>
    </div>
</div>
<app-footer></app-footer>
<lib-preloader [loading]="loading"></lib-preloader>
